webpackJsonp([265343770855089],{

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _events = __webpack_require__(98);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _styles = __webpack_require__(15);
	
	var _withRoot = __webpack_require__(16);
	
	var _withRoot2 = _interopRequireDefault(_withRoot);
	
	var _Masthead = __webpack_require__(61);
	
	var _Masthead2 = _interopRequireDefault(_Masthead);
	
	var _Nav = __webpack_require__(43);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Divider = __webpack_require__(60);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _root_SmallDivider = __webpack_require__(84);
	
	var _root_SmallDivider2 = _interopRequireDefault(_root_SmallDivider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistryPage = function RegistryPage(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Masthead2.default, null),
	    _react2.default.createElement(_Nav2.default, null),
	    _react2.default.createElement(_Divider2.default, null),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: classes.title },
	        'Registry'
	      ),
	      _react2.default.createElement('img', { src: _root_SmallDivider2.default, alt: 'curved line', className: classes.smallDivider }),
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: '80px' } },
	        _react2.default.createElement(
	          'div',
	          { style: { margin: '0 auto', maxWidth: '1170px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { margin: '0 8.3334%' } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex' } },
	              _react2.default.createElement(
	                'div',
	                { className: classes.infoContainer },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    style: {
	                      marginBottom: '30px',
	                      textAlign: 'center'
	                    }
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h3',
	                      { style: { fontFamily: 'Lulu Clean One Bold' } },
	                      'Target'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: '40px' } },
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        className: classes.anchor,
	                        href: 'https://www.target.com/gift-registry/giftgiver?registryId=4568809b445c4701812599f615b989bd&lnk=registry_custom_url',
	                        target: '_blank'
	                      },
	                      'View Registry'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withRoot2.default)((0, _styles.withStyles)(_events2.default)(RegistryPage));
	module.exports = exports['default'];

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = styles;
	function styles(theme) {
	  return {
	    title: {
	      'font-family': 'Lulu Clean One Bold',
	      'text-align': 'center'
	    },
	    smallDivider: {
	      display: 'block',
	      height: '50px',
	      width: '200px',
	      margin: '0 auto 30px'
	    },
	    infoContainer: {
	      display: 'flex',
	      'flex-direction': 'column',
	      'align-items': 'center',
	      'flex-grow': 1,
	      'flex-basis': 0,
	      padding: '0 15px',
	      'text-align': 'left'
	    },
	    anchor: {
	      'text-transform': 'uppercase',
	      color: 'rgb(146, 148, 146)',
	      'text-decoration': 'none',
	      'border-width': '1px',
	      'border-style': 'solid',
	      'border-color': 'transparent',
	      'background-color': 'transparent'
	    }
	  };
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-registry-js-990bbaa83a70b18e10cd.js